var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('h2',{staticClass:"title"},[_vm._v("智慧营销体系")]),_vm._v(" "),_vm._l((_vm.list),function(item){return _c('p',{key:item.id,staticClass:"item",class:{ active: item.id == _vm.type },on:{"click":function($event){return _vm.jumpPages(item.url)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-118568e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/ColumnTab.vue
// module id = null
// module chunks = 